import { useChatStore } from "../../state/chat";
import { useCinematicStore } from "../../state/cinematic";
import styles from "./MetaFooter.module.css";

export function MetaFooter() {
  const mode = useChatStore((s) => s.mode);
  const paused = useCinematicStore((s) => s.paused);

  return (
    <footer className={styles.footer}>
      <div className={styles.left}>
        <span className={styles.pulse} aria-hidden />
        <span className={styles.status}>session · live</span>
        <span className={styles.sep}>·</span>
        <span className={styles.muted}>sse · ok</span>
      </div>
      <div className={styles.center}>
        {mode === "cinematic" &&
          (paused ? (
            <span className={styles.paused}>
              <span className={styles.pausedDot} aria-hidden />
              paused · <Key>p</Key> to resume
            </span>
          ) : (
            <span className={styles.shortcut}>
              <Key>p</Key> pause · <Key>s</Key> skip · <Key>r</Key> replay
            </span>
          ))}
      </div>
      <div className={styles.right}>
        <span className={styles.muted}>▾ bite back · build 0.1</span>
      </div>
    </footer>
  );
}

function Key({ children }: { children: string }) {
  return <kbd className={styles.key}>{children}</kbd>;
}
